import type { RootState } from '@core/Store'

export const selectIsSkyVideoPlayerOpen = ({ skyVideoPlayer }: RootState) =>
  skyVideoPlayer.isPlayerOpen

export const selectIsDockedSkyVideoPlayerOpen = ({ skyVideoPlayer }: RootState) =>
  skyVideoPlayer.playerStatus === 'docked' && skyVideoPlayer.isPlayerOpen

export const selectDockedPlayerHeight = ({ skyVideoPlayer }: RootState) =>
  skyVideoPlayer.dockedPlayerHeight

export const selectCanRenderPendingBetsDrawer = ({ skyVideoPlayer }: RootState) =>
  skyVideoPlayer.canRenderPendingBetsDrawer

export const selectIsPendingBetsDrawerOpen = ({ skyVideoPlayer }: RootState) =>
  skyVideoPlayer.isPendingBetsDrawerOpen

export const selectVideoPlayerChannel = ({ skyVideoPlayer }: RootState) =>
  skyVideoPlayer.selectedChannel

export const selectVideoPlayerStatus = ({ skyVideoPlayer }: RootState) =>
  skyVideoPlayer.playerStatus

export const selectRaceReplay = ({ skyVideoPlayer }: RootState) => ({
  trackName: skyVideoPlayer.raceReplayTitle?.trackName,
  raceNumber: skyVideoPlayer.raceReplayTitle?.raceNumber,
  meetingDate: skyVideoPlayer.raceReplayMeetingDate,
})

export const selectIsVideoPlaying = ({ skyVideoPlayer }: RootState) => skyVideoPlayer.isPlaying

export const selectSky1SecureUrl = ({ skyVideoPlayer }: RootState) => skyVideoPlayer.sky1SecureUrl

export const selectSky2SecureUrl = ({ skyVideoPlayer }: RootState) => skyVideoPlayer.sky2SecureUrl

export const selectSecureUrlExpiry = ({ skyVideoPlayer }: RootState) =>
  skyVideoPlayer.secureUrlExpiry
